import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState
} from 'react';
import { NextParsedUrlQuery } from 'next/dist/server/request-meta';

import {
  IBlogPost,
  IGlobalConfiguration,
  IGlobalConfigurationFields,
  ILearningCenterArticle,
  IPage,
  IPageFields
} from '@/types/contentful';

import { Cookies } from '../../modules/cookies/getServerSideCookies';
import { UserData } from '../../lib/referrals/getUserDataById';

export enum envEnum {
  development = 'development',
  preview = 'preview',
  staging = 'staging',
  production = 'production'
}

export type UrlByEnv = {
  [key in envEnum]?: string;
};

export interface PageFieldProps {
  page?: IPageFields;
  config?: IGlobalConfigurationFields;
  webregIncident?: boolean;
  cookies?: Cookies;
  query?: any;
  advocateUserData?: UserData | null;
  minAprAmount?: number;
  maxAprAmount?: number;
  effectiveDateConversion?: any;
}

export interface PageProps {
  query?: NextParsedUrlQuery;
  slug?: string | null;
  pageData?: IPage;
  blogPostData?: IBlogPost;
  articleData?: ILearningCenterArticle;
  globalConfig?: IGlobalConfiguration;
  cookies?: Cookies;
  advocateUserData?: UserData;
  minAprAmount?: number;
  maxAprAmount?: number;
  effectiveDateConversion?: any;
}

export interface PageProvider extends PageProps {
  children?: ReactNode | ReactNode[];
}

export const PageContext = createContext<PageFieldProps>({} as PageFieldProps);

export const usePageDataContext = () => useContext(PageContext);

export function PageDataProvider({
  globalConfig,
  pageData,
  query,
  cookies,
  children,
  advocateUserData,
  minAprAmount,
  maxAprAmount,
  effectiveDateConversion
}: PageProvider) {
  const [webregIncident, setIncidentResponse] = useState(
    globalConfig?.fields?.enableIncidentResponse ?? false
  );

  useEffect(() => {
    window.setIncident = setIncidentResponse;
  }, []);

  return (
    <PageContext.Provider
      value={{
        config: globalConfig?.fields,
        page: pageData?.fields,
        query,
        webregIncident,
        cookies: cookies ?? ({} as Cookies),
        advocateUserData,
        minAprAmount,
        maxAprAmount,
        effectiveDateConversion
      }}
    >
      {children}
    </PageContext.Provider>
  );
}
